import {curry} from 'ramda';

import humanizeRange from '@pluto/humanize-moment-range';
import {DateRangeState} from '@pluto/daterange-picker';
import {FilterHandlers} from '../../QCWorkflow/QCManager/QCManagerTypes';
import {QCStatus} from '../../QCWorkflow/QCFilters/QCFiltersType';

export interface NewFilters {
    qcJobStatus: QCStatus;
    newDates: DateRangeState;
}

export const handlePreselect = curry(
    (filterHandlers: FilterHandlers, newValues: NewFilters): void => {
        const {
            setFilters,
            setPage,
            setQuery,
            history,
            setQCJobs,
            rowsPerPage,
            filters,
            title,
            sortOrder,
            sortBy,
            route,
        } = filterHandlers;
        const {qcJobStatus, newDates} = newValues;
        const [finishDateStart, finishDateEnd] = humanizeRange(newDates);
        const newFilters = {
            ...filters,
            qcJobStatus,
        };
        const query = {
            ...newFilters,
            offset: 0,
            title,
            limit: rowsPerPage,
            sortOrder,
            sortBy,
            finishDateStart,
            finishDateEnd,
        };

        setPage(0);
        setQuery(history, route, query);
        setFilters(newFilters);
        setQCJobs(query);
    }
);
